var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.519,
    height: 20.519,
    viewBox: "0 0 20.519 20.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28467",
    "data-name": "Group 28467",
    transform: "translate(-3843.3 2941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28466",
    "data-name": "Group 28466",
    transform: "translate(3839.839 -2943.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27941",
    "data-name": "Group 27941",
    transform: "translate(3.46 4.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16659",
    "data-name": "Path 16659",
    d: "M20.661,6.256,19.339,4.792,9.515,14.543,5.2,10.234,3.46,11.554l6.054,6.066Z",
    transform: "translate(-3.46 -4.792)",
    fill: "#0074b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7915",
    "data-name": "Rectangle 7915",
    width: 14.244,
    height: 2.035,
    transform: "translate(1.446 13.619)",
    fill: "#0074b0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIconBlue);
export default __webpack_public_path__ + "static/media/saveIcon-blue.c856577e2905d9df174e030eebfb8a5d.svg";
export { ForwardRef as ReactComponent };